module.exports = __webpack_public_path__ + "img/repense-logo.23010b0e.png";